import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule } from '@spartacus/core';

import { AimoClosingtimeComponent } from './aimo-closingtime.component';

@NgModule({
    imports: [CommonModule, RouterModule, I18nModule, NgbTooltipModule, NgbPopoverModule],
    declarations: [AimoClosingtimeComponent],
    exports: [AimoClosingtimeComponent],
})
export class AimoClosingtimeModule {}
